
export const city=[
    {
        city:"USA",
        link:"/seo/services/usa/"
    },
    {
        city:"Delaware",
        link:"/seo/services/delaware/"
    },
    {
        city:"Los angeles",
        link:"/seo/services/los-angeles/"
    },
    {
        city:"San Diego",
        link:"/seo/services/san-diego/"
    },
    {
        city:"Newyork",
        link:"/seo/services/newyork/"
    },
    {
        city:"Indianapolis",
        link:"/seo/services/indianapolis/"
    },
    {
        city:"Florida",
        link:"/seo/services/florida/"
    },
    {
        city:"Dallas",
        link:"/seo/services/dallas/"
    },
    {
        city:"Phoenix",
        link:"/seo/services/phoenix/"
    },
    // {
    //     city:"Texas",
    //     link:"/seo/services/texas/"
    // },
    {
        city:"India",
        link:"/seo/company/india/"
    },
    {
        city:"Mumbai",
        link:"/seo/company/mumbai/"
    },
    {
        city:"Jaipur",
        link:"/seo/company/jaipur/"
    },
    {
        city:"Gurgaon",
        link:"/seo/company/gurgaon/"
    },
    {
        city:"Delhi",
        link:"/seo/company/delhi/"
    },
    {
        city:"Noida",
        link:"/seo/company/noida/"
    },
    {
        city:"Pune",
        link:"/seo/company/pune/"
    },
    // {
    //     city:"Bengaluru",
    //     link:"/seo/company/bengaluru/"
    // },
    // {
    //     city:"Ahemdabad",
    //     link:"/seo/company/ahemdabad/"
    // },
    // {
    //     city:"Chennai",
    //     link:"/seo/company/chennai/"
    // },
    // {
    //     city:"Kolkata",
    //     link:"/seo/company/kolkata/"
    // }
   
    
]